export default function RegisterForm({ register }) {
  const {
    form,
    roles,
    managers,
    sbuHeads,
    loading,
    roleLower,
    disableRM,
    handleInput,
    handleSubmit,
  } = register;

  return (
    <form onSubmit={handleSubmit}>
      <div className="dr-reg-grid">

        <div className="dr-full">
          <label className="dr-reg-label">Employee ID</label>
          <input
            className="dr-reg-input"
            name="empID"
            value={form.empID}
            onChange={handleInput}
            required
          />
        </div>

        <div className="dr-full">
          <label className="dr-reg-label">Full Name</label>
          <input
            className="dr-reg-input"
            name="name"
            value={form.name}
            onChange={handleInput}
            required
          />
        </div>

        <div>
          <label className="dr-reg-label">Designation</label>
          <input
            className="dr-reg-input"
            name="designation"
            value={form.designation}
            onChange={handleInput}
            required
          />
        </div>

        <div>
          <label className="dr-reg-label">Location</label>
          <input
            className="dr-reg-input"
            name="location"
            value={form.location}
            onChange={handleInput}
            required
          />
        </div>

        <div>
          <label className="dr-reg-label">Email ID</label>
          <input
            type="email"
            className="dr-reg-input"
            name="email"
            value={form.email}
            onChange={handleInput}
            required
          />
        </div>

        <div>
          <label className="dr-reg-label">Password</label>
          <input
            type="password"
            className="dr-reg-input"
            name="password"
            value={form.password}
            onChange={handleInput}
            required
          />
        </div>

        <div className="dr-full">
          <label className="dr-reg-label">Role</label>
          <select
            className="dr-reg-select"
            name="roleName"
            value={form.roleName}
            onChange={handleInput}
            required
          >
            <option value="">Select Role</option>
            {roles.map((r) => (
              <option key={r.id} value={r.name}>
                {r.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="dr-reg-label">Reporting Manager</label>
          <select
            className="dr-reg-select"
            name="reportingManagerName"
            value={form.reportingManagerName}
            disabled={disableRM}
            onChange={handleInput}
            required={roleLower === "employee"}
          >
            <option value="">
              {disableRM ? "Auto-selected" : "Select Reporting Manager"}
            </option>
            {managers.map((m) => (
              <option key={m.ID} value={m.Name}>
                {m.Name} ({m.empID})
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="dr-reg-label">SBU Head</label>
          <select
            className="dr-reg-select"
            name="sbuHeadName"
            value={form.sbuHeadName}
            onChange={handleInput}
            required={roleLower !== "employee"}
          >
            <option value="">Select SBU Head</option>
            {sbuHeads.map((s) => (
              <option key={s.ID} value={s.Name}>
                {s.Name}
              </option>
            ))}
          </select>
        </div>

        <button className="dr-reg-btn" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button>

      </div>
    </form>
  );
}
